import React, { useEffect, useState } from 'react';
import Logo from '../components/Logo';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Static defaults shown until the partial-auth handbook fetch resolves (and
// kept if it fails). Intentionally generic -- no admin email or mailto link
// is rendered anywhere on this page, by design. An admin can edit the
// ``title`` / ``message`` text via PUT /api/handbook/escalation_contacts.
const DEFAULT_TITLE = 'Access required';
const DEFAULT_MESSAGE =
  'Please reach out to your team administrator to be added to the employee database.';

const NotInDatabasePage = ({ user }) => {
  const [escalation, setEscalation] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchEscalation = async () => {
      try {
        const res = await fetch(
          `${API_BASE}/api/handbook/partial/escalation_contacts`,
          { credentials: 'include' }
        );
        if (!res.ok) throw new Error(`status ${res.status}`);
        const data = await res.json();
        if (!cancelled) setEscalation(data?.entry?.content || {});
      } catch (e) {
        console.error('Error fetching escalation copy:', e);
        if (!cancelled) setEscalation({});
      }
    };
    fetchEscalation();
    return () => { cancelled = true; };
  }, []);

  const escalationTitle = escalation?.title || DEFAULT_TITLE;
  const escalationMessage = escalation?.message || DEFAULT_MESSAGE;

  const handleSignOut = () => {
    // Clear any stored auth data
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('originalAdminUser');
    
    // Redirect to login
    window.location.href = '/';
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
        padding: '48px',
        maxWidth: '500px',
        width: '100%',
        textAlign: 'center'
      }}>
        <Logo />
        
        <div style={{ marginTop: '32px' }}>
          <div style={{
            width: '64px',
            height: '64px',
            background: '#FEE2E2',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 24px',
            fontSize: '32px'
          }}>
            ⚠️
          </div>
          
          <h1 style={{
            fontSize: '28px',
            fontWeight: '700',
            color: 'var(--symbolica-black)',
            marginBottom: '16px',
            lineHeight: '1.2'
          }}>
            Account Not Found
          </h1>
          
          {user && (
            <div style={{
              background: '#F0EDE6',
              borderRadius: '8px',
              padding: '12px',
              marginBottom: '24px'
            }}>
              <div style={{
                fontSize: '14px',
                color: 'var(--symbolica-muted)',
                marginBottom: '4px'
              }}>
                Logged in as:
              </div>
              <div style={{
                fontSize: '16px',
                color: 'var(--symbolica-black)',
                fontWeight: '500'
              }}>
                {user.name || user.email}
              </div>
              <div style={{
                fontSize: '14px',
                color: 'var(--symbolica-muted)'
              }}>
                {user.email}
              </div>
            </div>
          )}
          
          <p style={{
            fontSize: '16px',
            color: '#4b5563',
            lineHeight: '1.6',
            marginBottom: '32px'
          }}>
            Your Google account has been authenticated successfully, but you are not yet registered in the employee database.
          </p>
          
          <div style={{
            background: '#EFF6FF',
            border: '1px solid #BFDBFE',
            borderRadius: '8px',
            padding: '16px',
            marginBottom: '32px'
          }}>
            <p style={{
              fontSize: '14px',
              color: '#1e40af',
              margin: '0 0 8px 0',
              fontWeight: '500'
            }}>
              {escalationTitle}
            </p>
            <p style={{
              fontSize: '13px',
              color: '#1e40af',
              margin: 0,
              lineHeight: '1.5',
            }}>
              {escalationMessage}
            </p>
          </div>
          
          <button
            onClick={handleSignOut}
            style={{
              background: 'var(--symbolica-muted)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              fontSize: '16px',
              fontWeight: '500',
              cursor: 'pointer',
              transition: 'background 0.2s',
              width: '100%'
            }}
            onMouseEnter={(e) => e.target.style.background = '#4b5563'}
            onMouseLeave={(e) => e.target.style.background = 'var(--symbolica-muted)'}
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotInDatabasePage;
